import { Component, Inject, Prop } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';

/**
 * Componente que permite la descarga de la guia de formalizacion.
 * @extends ApeironComponent
 */
@Component({
  computed: {
    userInfo: {
      get() {
        return this.$store.getters.userInfo;
      },
    },
  },
})
export default class GuiaFormalizacionComponent extends ApeironComponent {
  @Prop({ default: false })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public solucion: Solucion;

  public isCaptura = false;
  public issste = false;
  public isApoyos = false;
  public isGeneral = false;
  public guiaISSSTE =
    'https://secihti.mx/wp-content/uploads/becas/becas_extranjero/documentos_restringidos/2026/Guia_Asignacion_Formalizacion_BEXT_RMYET_2026.pdf';
  public guiaApoyos = ' https://enbc.secihti.mx/wp-content/uploads/2026/02/Guia_Postulacion_BEXT_ACMYP_2026-20260423T235749.pdf';
  public guiaGeneral =
    'https://secihti.mx/wp-content/uploads/becas/becas_extranjero/documentos_restringidos/2026/Guia_Asignacion_Formalizacion_BEXT_2026.pdf';
  public loadingInstituciones = false;

  /**
   * Método ejecutado al crear el componente.
   */
  created(): void {
    this.isCaptura = this.formModel.estado === EstadoSolicitud.EN_CAPTURA || this.formModel.estado === EstadoSolicitud.RECHAZADA;
    this.issste = this.solucion.params.tipoBecaExtranjero === 'CONVENIO_ISSSTE';
    this.isApoyos = this.solucion.params.tipoBecaExtranjero === 'APOYOS_COMPLEMENTARIOS_EXT';
    this.isGeneral =
      this.solucion.params.tipoBecaExtranjero === 'CREACION_FUTURO' ||
      this.solucion.params.tipoBecaExtranjero === 'CIENCIAS_HUMANIDADES' ||
      this.solucion.params.tipoBecaExtranjero === 'ESPECIALIDADES_MEDICAS';
  }
}
